/**
 * Direct unsigned browser→Cloudinary upload — no backend signing needed.
 * Approved Phase 1 exception (see CLAUDE.md): the only cloud service used
 * before Phase 2, because standing up a real local MinIO server for one
 * feature (employee photos) wasn't worth the setup cost at this stage.
 *
 * Requires a free Cloudinary account + an Upload Preset with
 * Signing Mode = Unsigned. Configure via VITE_CLOUDINARY_CLOUD_NAME and
 * VITE_CLOUDINARY_UPLOAD_PRESET in .env.development.
 */

const CLOUD_NAME = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET;

export const isCloudinaryConfigured = () =>
  !!CLOUD_NAME && CLOUD_NAME !== 'your_cloud_name' && !!UPLOAD_PRESET && UPLOAD_PRESET !== 'your_unsigned_preset_name';

/**
 * Uploads an image file directly to Cloudinary and returns its secure_url.
 * Throws with a friendly message if Cloudinary isn't configured or the
 * upload fails (caller should catch and toast).
 */
export async function uploadToCloudinary(file) {
  if (!isCloudinaryConfigured()) {
    throw new Error('Photo upload is not configured yet. Set VITE_CLOUDINARY_CLOUD_NAME and VITE_CLOUDINARY_UPLOAD_PRESET in .env.development.');
  }
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('folder', 'attendx/employee-photos');

  const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
    method: 'POST',
    body: formData,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.error?.message || 'Photo upload failed');
  }
  const data = await res.json();
  return data.secure_url;
}
